// Calculate optimal number of drivers for a set of lights
export const calculateLightDrivers = (drivers, lights) => {
    const totalPower = lights.reduce((acc, { wattage }) => acc + wattage, 0);
    const totalPorts = lights.reduce((acc, { ports }) => acc + ports, 0);
    const driversToUse = Object.fromEntries(drivers.map(({ name }) => [name, 0]));
    const sortedDrivers = drivers.sort((a, b) => a.wattage - b.wattage);
    sortedDrivers.forEach((driver1, i) => {
        // For the first (weakest) driver, we calculate the number of this
        // driver needed to power all the provided lights
        let nDriver1 = i === 0
            ? Math.ceil(Math.max(totalPower / driver1.wattage, totalPorts / driver1.ports))
            : driversToUse[driver1.name];
        // Find the next (more powerful) driver
        const driver2 = sortedDrivers[i + 1];
        if (driver2) {
            let nDriver2 = driversToUse[driver2.name];
            // At how many number of driver1s is it more affordable to upgrade to driver2
            const priceThreshold = driver2.price / (driver1.price || 1);
            // How many (power/port wise) driver1s correspond to a single driver2
            const driverRatio = Math.ceil(Math.min(driver2.wattage / driver1.wattage, driver2.ports / driver1.ports));
            // While it's more affordable to upgrade
            while (nDriver1 >= priceThreshold) {
                // Subtract correct number of driver1s
                nDriver1 = Math.max(nDriver1 - driverRatio, 0);
                // Add a single driver2
                nDriver2 += 1;
            }
            driversToUse[driver2.name] = nDriver2;
        }
        driversToUse[driver1.name] = nDriver1;
    });
    return driversToUse;
};
//# sourceMappingURL=drivers.js.map